import * as React from 'react';

interface IProps {
    isLoading: boolean;
    loadMoreAction(): void;
}

class LoadingMoreComp extends React.Component<IProps, any> {
    public render() {
        const props = this.props;
        return (
            <div className={`ui-loading ${props.isLoading ? 'disabled' : ''}`} onClick={() => props.loadMoreAction()}>
                <span>{props.isLoading ? '加载中' : '点击加载更多'}</span>
                <div className={`ui-loading-ani ${props.isLoading ? 'active' : ''}`}>
                    <div className="load-container load-a">
                        <div className="loader">Loading...</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default LoadingMoreComp;


// WEBPACK FOOTER //
// ./src/components/common/loading-more.tsx